export default function Template(props) {
    return <div className="NotificationTitle">
        ЗАПОВНЕНА ФОРМА
    </div>
}
